import { motion } from "framer-motion";
import { EXPERIENCES } from "../../data/content";

export const Experiences = () => {
  return (
    <section
      id="experiences"
      data-testid="experiences-section"
      className="relative bg-sand-100 py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-16">
          <p className="text-xs tracking-[0.25em] uppercase text-earth-600 font-semibold mb-5">
            Experiences
          </p>
          <h2 className="font-serif font-light text-forest-900 text-3xl sm:text-5xl leading-tight text-balance">
            The reserve is your playground
          </h2>
          <p className="text-forest-500 text-base sm:text-lg leading-relaxed mt-5">
            From whale season on the Pacific to silent walks through ancient
            mangroves — every day here is shaped by the wild.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {EXPERIENCES.map((exp, i) => (
            <motion.article
              key={exp.id}
              data-testid={`experience-card-${exp.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`group relative overflow-hidden rounded-3xl min-h-[22rem] flex flex-col justify-end ${
                i === 0 ? "lg:row-span-2 lg:min-h-[30rem]" : ""
              }`}
            >
              <img
                src={exp.image}
                alt={exp.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-forest-900/90 via-forest-900/20 to-transparent" />
              <div className="relative p-6">
                <span className="inline-block rounded-full bg-earth-500/90 text-white text-[0.65rem] font-semibold tracking-wide px-3 py-1 mb-3 uppercase">
                  {exp.season}
                </span>
                <h3 className="font-serif text-2xl text-sand-100 mb-2">
                  {exp.title}
                </h3>
                <p className="text-sand-200/85 text-sm leading-relaxed">
                  {exp.desc}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
